<template>
  <el-dialog
    :title="openType === 'add' ? '新增分类' : '编辑分类'"
    :visible.sync="visible"
    :close-on-click-modal="false"
    destroy-on-close
    custom-class="customModal" >
    <el-form ref="form" :model="formValue" :rules="rules">
      <el-form-item label="名称" prop="name" class="formItemFill">
        <el-input v-model="formValue.name" size="small" autocomplete="off"></el-input>
      </el-form-item>
      <el-row>
        <el-col :span="24">
          <el-form-item label="排序" prop="sort" class="formItemFill" >
            <el-input type="number" v-model.number="formValue.sort" autocomplete="off"/>
          </el-form-item>
        </el-col>
      </el-row>
      <el-form-item label="是否显示" class="formItemFill">
        <el-radio-group v-model="formValue.is_enable" size="small" style="width: 100%">
          <el-radio-button :label="1">是</el-radio-button>
          <el-radio-button :label="0">否</el-radio-button>
        </el-radio-group>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <AppButton type="primary" @click="submit" size="small">确 定</AppButton>
      <AppButton @click="close" size="small">取 消</AppButton>
    </div>
  </el-dialog>
</template>

<script>
import { ArticleService } from '../../service/article.service';
  export default {
    name: 'formAuthorize',
    data() {
      return {
        visible: false,
        openType: '',
        formValue: { },
        rules: {
          name: [{ required: true, message: '分类名称不能为空', tigger: 'blur' }],
          sort: [{ required: true, type:'number', message: '排序不能为空', tigger: 'blur' }]
        }
      }
    },
    methods: {
      async open(type, data) {
        if (type === 'add') {
          this.reset();
        } 
        else if (type === 'edit') {
          const result = JSON.parse(JSON.stringify(await ArticleService.getClassficationListDetail(data.id)));
          this.formValue = result;
        }
        this.openType = type;
        this.visible = true;
      },
      reset() {
        this.formValue = {
          is_enable: 1
        };
      },
      async submit() {
        const result = await this.$refs.form.validate();
        if (result) {
          await ArticleService.submitArticleClassification(this.formValue);
          this.$emit('submitSuccess')
          this.close();
        }
      },
      close() {
        this.visible = false;
        this.formValue = {};
      }
    }
  }
</script>

<style lang="scss" scoped>

</style>